<template>
  <div>
    <no-site v-if="noSiteId"></no-site>
    <template v-else>
      <page-loader v-if="fetchingSites"></page-loader>
      <template v-else>
          <no-site v-if="sites.length < 1"></no-site>
          <page-loader v-else-if="loading"></page-loader>
          <template v-else>
            <slot></slot>
          </template>
      </template>
    </template>
  </div>
</template>

<script>
import { SiteCacheMixin } from '@/mixins/Booking/SiteCacheMixin'
import { TimeFormatMixin } from '@/mixins/Booking/TimeFormatMixin'
import { DateFormatMixin } from '@/mixins/Booking/DateFormatMixin'
import PageLoader from '../Loading/PageLoader.vue'
import NoSiteFound from '../Booking/NoSiteFound.vue'

export default {
  name: 'SettingsChecker',
  mixins: [SiteCacheMixin, TimeFormatMixin, DateFormatMixin],
  computed: {
    noSiteId () {
      return !this.siteId
    },
    loading () {
      return this.fetchingSites ||
        this.fetchingTimeFormatOptions ||
        this.fetchingDateFormatOptions ||
        this.loadingDateFormatSetting ||
        this.loadingTimeFormatSetting
    }
  },
  components: {
    'page-loader': PageLoader,
    'no-site': NoSiteFound
  }
}
</script>
